import React from 'react';
import PropTypes from 'prop-types';
import CompanyAdminSettingView from '../company-settings-form-view';
import { CompanyAdminSettingsForm } from '../company-settings-form';

export const CompanyAdminSettingsContent = ({
	isCompanyAdminSettingInfoLoading,
	formValues,
	companyAdminSettingInfo,
	isEditing,
	change,
}) => {
	if (isEditing) {
		return (
			<CompanyAdminSettingsForm
				formValues={formValues}
				change={change}
				companyAdminSettingInfo={companyAdminSettingInfo}
			/>
		);
	}

	return (
		<CompanyAdminSettingView
			companyAdminSettingInfo={companyAdminSettingInfo}
			isCompanyAdminSettingInfoLoading={isCompanyAdminSettingInfoLoading}
			formValues={formValues}
		/>
	);
};

CompanyAdminSettingsContent.propTypes = {
	companyAdminSettingInfo: PropTypes.object,
	isCompanyAdminSettingInfoLoading: PropTypes.bool.isRequired,
	isEditing: PropTypes.bool.isRequired,
	formValues: PropTypes.object,
	change: PropTypes.func.isRequired,
	initialValues: PropTypes.array,
};
